import { render, staticRenderFns } from "./BankForm.vue?vue&type=template&id=337f537c&scoped=true"
import script from "./BankForm.vue?vue&type=script&lang=js"
export * from "./BankForm.vue?vue&type=script&lang=js"
import style0 from "./BankForm.vue?vue&type=style&index=0&id=337f537c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "337f537c",
  null
  
)

export default component.exports